import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Row, Col, Progress } from 'reactstrap';
import styled, { css, keyframes } from 'styled-components';
import C3Chart from './C3Chart';
import 'c3/c3.css';
import Img from 'react-image';

import church from '../img/church.jpg';
import './InfoPais.css';
import { SSemiFixedContainer, SFixed, SScrollStretch } from './SemifixedLayout';

export default class InfoPartido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pais1: props.partido ? props.partido.pais1 : null,
      pais2: props.partido ? props.partido.pais2 : null,
      fecha: props.partido ? props.partido.fecha : null,
      atributoSeleccionado: props.atributoSeleccionado,
      atributos: props.atributos
    };
    this.atrSel = props.atributoSeleccionado;
  }

  render() {
    const t = this.props.t;
    const i18n = this.props.i18n;
    // this.atrSel = this.state.atributoSeleccionado;
    const pais1 = this.state.pais1;
    const pais2 = this.state.pais2;
    const fecha = this.state.fecha;
    const xs = 12;
    const SStadium = this.SStadium;
    const SFlag = this.SFlag;
    const SOpciones = this.SOpciones;
    const SH4 = this.SH4;
    const atributos = this.state.atributos;
    if (!(pais1 && pais2 && fecha)) {
      return (
        <SSemiFixedContainer {...this.props}>
          <SFixed>
            <Row>
              <Col xs={12}>
                <SStadium src={church} alt={`${t('Iglesia del Salvador sobre la sangre derramada')}. ${t('Por')} Je-str [CC BY-SA 3.0 (https://creativecommons.org/licenses/by-sa/3.0)], ${t('tomada de')} Wikimedia Commons. ${t('Adapatada')}.`} i18n={i18n} />
              </Col>
              <Col xs={12}>
                <Row>
                  <Col xs={6}>
                    <SFlag
                      src={`${this.props.urlBase}/img/banderas/banderaVacia.svg`}
                      alt={`${t('Partido no seleccionado')}.`}
                    />
                  </Col>
                  <Col xs={6}>
                    <SFlag
                      src={`${this.props.urlBase}/img/banderas/banderaVacia.svg`}
                      alt={`${t('Partido no seleccionado')}.`}
                    />
                  </Col>
                  <Col xs={12}>
                    <SH4>{t('Seleccione un partido')}</SH4>
                  </Col>
                </Row>
              </Col>
            </Row>
          </SFixed>
          <SScrollStretch>
            <SOpciones
              // color1="#D54733"
              // color2="#0E5D9E"
              color1="#faca15"
              color2="#1c7ca2"
              atributos={atributos}
              t={t}
            />
          </SScrollStretch>
        </SSemiFixedContainer>
      );
    }

    return (
      <SSemiFixedContainer className={this.props.className} style={this.props.style}>
        <SFixed>
          <Row>
            <Col xs={12}>
              <SStadium
                src={church}
                alt={`${t('Iglesia del Salvador sobre la sangre derramada')}. ${t('Por')} Je-str [CC BY-SA 3.0 (https://creativecommons.org/licenses/by-sa/3.0)], ${t('tomada de')} Wikimedia Commons. ${t('Adapatada')}.`}
                fecha={fecha}
                i18n={i18n}
              />
            </Col>
            <Col xs={12}>
              <Row>
                <Col xs={6}>
                  <SFlag
                    src={`${this.props.urlBase}/img/banderas/${pais1.iso_code}.svg`}
                    alt={`${t('Bandera de')} ${t(pais1.seleccion)}.`}
                  />
                  <SH4>{t(pais1.seleccion)}</SH4>
                </Col>
                <Col xs={6}>
                  <SFlag
                    src={`${this.props.urlBase}/img/banderas/${pais2.iso_code}.svg`}
                    alt={`${t('Bandera de')} ${t(pais2.seleccion)}.`}
                  />
                  <SH4>{t(pais2.seleccion)}</SH4>
                </Col>
              </Row>
            </Col>
          </Row>
        </SFixed>
        <SScrollStretch>
          <SOpciones
            pais1={pais1}
            pais2={pais2}
            // color1="#D54733"
            // color2="#0E5D9E"
            color1="#faca15"
            color2="#1c7ca2"
            atributos={atributos}
            t={t}
          />
        </SScrollStretch>
      </SSemiFixedContainer>
    );
  }

  componentDidMount() {}

  componentDidUpdate() {}

  componentWillReceiveProps = nextProps => {
    this.setState({
      pais1: nextProps.partido ? nextProps.partido.pais1 : null,
      pais2: nextProps.partido ? nextProps.partido.pais2 : null,
      fecha: nextProps.partido ? nextProps.partido.fecha : null,
      atributoSeleccionado: nextProps.atributoSeleccionado,
      atributos: nextProps.atributos
    });
  };
  handleAttributeChange = attr => {
    this.props.onAtributoChange(attr);
  };
  Opcion = ({
    key,
    className,
    children,
    atributo,
    descripcionAtributo,
    color1,
    color2,
    valor1,
    valor2
  }) => {
    const SProgress = this.SProgress;
    return (
      <Col
        key={key}
        xs={12}
        className={className}
        onMouseOver={e => {
          this.handleAttributeChange(atributo);
        }}
        onMouseOut={e => {
          this.handleAttributeChange(this.atrSel);
        }}
        onClick={e => {
          this.handleAttributeChange(atributo);
          this.atrSel = atributo;
        }}
      >
        <Row className="align-items-center">
          <Col xs={4} sm={4} md={3} style={{ padding: '0', textAlign: 'center' }}>
            {valor1}
          </Col>
          <Col xs={4} sm={4} md={6} style={{ padding: '0' }}>
            <div style={{ position: 'relative', width: '100%' }}>
              {/* {descripcionAtributo} */}
              <SProgress
                value={valor1 + valor2 === 0 ? 0.5 : valor1}
                min={0}
                max={valor1 + valor2 === 0 ? 1 : valor1 + valor2}
                color1={color1}
                color2={color2}
              >
                <div className="justify-content-center d-flex position-absolute w-100">
                  {descripcionAtributo}
                </div>
              </SProgress>
            </div>
          </Col>
          <Col xs={4} sm={4} md={3} style={{ padding: '0', textAlign: 'center' }}>
            {valor2}
          </Col>
        </Row>
      </Col>
    );
  };
  Opciones = ({ pais1, pais2, atributos, t, color1, color2, ...props }) => {
    if (!atributos) {
      return <div />;
    }
    const SOpcion = this.SOpcion;
    const opciones = atributos.map((atributo, i) => {
      let valor1 = pais1
        ? pais1[atributo.nombre]
          ? pais1[atributo.nombre].valor
            ? pais1[atributo.nombre].valor
            : pais1[atributo.nombre]
          : 0
        : 0;
      let valor2 = pais1
        ? pais2[atributo.nombre]
          ? pais2[atributo.nombre].valor
            ? pais2[atributo.nombre].valor
            : pais2[atributo.nombre]
          : 0
        : 0;
      return (
        <SOpcion
          key={atributo.nombre}
          atributo={atributo.nombre}
          descripcionAtributo={atributo.descripcion}
          color1={color1}
          color2={color2}
          valor1={valor1}
          valor2={valor2}
        />
      );
    });
    return <div {...props}>{opciones}</div>;
  };
  SOpcion = styled(this.Opcion)`
    word-wrap: break-word;
    /* cursor: pointer; */
    /* transition: 0.05s border-color; */
    /* padding: 2px; */
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #fff;
    transition: border-color 0.5s ease-in-out;

    ${props =>
      (this.atrSel === props.valor || this.state.atributoSeleccionado === props.valor) &&
      css`
        border-color: #000;
      `};
  `;
  SOpciones = styled(this.Opciones)`
    background-color: #fff;
  `;
  SCrest = styled(Img)`
    width: 100%;
    height: auto;
    max-height: 15em;
    padding: 2em;
    margin: none;
    align-self: center;
    object-fit: contain;
  `;
  SStadiumImg = styled(Img)`
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* filter: blur(2px); */
  `;
  SStadium = (props, context) => {
    const SStadiumImg = this.SStadiumImg;
    const SContainer = this.SOverlayContainer;
    const SOverlay = this.SOverlay;
    return (
      <SContainer>
        <SStadiumImg {...props} />
        <SOverlay {...props} />
      </SContainer>
    );
  };
  SOverlay = (props, context) => {
    const i18n = props.i18n;
    let language = i18n.language;
    if (language.length > 2 && language.charAt(2) !== '-') {
      language = `${language.slice(0,2)}-${language.slice(2)}`;
    }
    let dateString = props.fecha
      ? props.fecha.toLocaleDateString(language, {
          weekday: 'long',
          month: 'long',
          day: 'numeric' 
        })
      : '';
    let timeString = props.fecha
    ? props.fecha.toLocaleTimeString(language, {
        hour12: true,
        hour: 'numeric'
      })
    : '';
    if (dateString && dateString[0]) {
      dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
    }
    const SOverlayContent = this.SOverlayContent;
    const SH4 = this.SH4;
    return (
      <SOverlayContent>
        <div
          style={{
            display: 'table',
            height: '100%',
            width: '100%'
          }}
        >
          <SH4
            style={{
              display: 'table-cell',
              height: '100%',
              verticalAlign: 'bottom',
              padding: '0.2em'
            }}
          >
            <span style={{whiteSpace: 'nowrap'}}>
              {dateString ? dateString + ', ' : ''}
            </span>
            <wbr/>
            <span style={{whiteSpace: 'nowrap'}}>
              {timeString}
            </span>
          </SH4>
        </div>
      </SOverlayContent>
    );
  };
  SOverlayContent = styled.div`
    position: absolute;
    top: 0;
    height: 5em;
    width: 100%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 1) 100%);
    object-fit: cover;
    color: white;
    /* filter: blur(2px); */
  `;
  SOverlayContainer = styled.div`
    position: relative;
    height: 5em;
    width: 100%;
    border: 1px solid black;
    object-fit: cover;
    /* filter: blur(2px); */
  `;
  LoaderAnimation = keyframes`
    0% {
      background: white;
    }
    100% {
      background: orange;
    }
  `;
  Loader = styled.div`
    isplay: block;
    border: 1px solid black;
    width: 100%;
    height: 7em;
    object-fit: cover;
    transition: background-color 1s ease-in-out;
    animation: ${this.LoaderAnimation} 2s ease-in-out 0s infinite;
  `;
  FImg = (props, context) => {
    const Loader = this.Loader;
    return <Img {...props} loader={<Loader />} />;
  };
  SFlag = styled(this.FImg)`
    display: block;
    border: 1px solid black;
    width: 100%;
    height: 7em;
    object-fit: cover;
  `;
  SProgress = styled(Progress)`
    background: ${props => props.color2};
    & > div {
      background: ${props => props.color1};
    }
    font-weight: 500;
  `;
  SH4 = styled.h4`
    width: 100%;
    height: 2em;
    text-align: center;
  `;
}



// WEBPACK FOOTER //
// ./src/componentes/InfoPartido.js